import { makeApiSuccess } from 'scenes/common/helpers/apiData';
import {
  ApiData,
  Campaign,
  CampaignAdjustment,
  CampaignElement,
  CampaignElementType,
} from 'scenes/common/types';

import {
  WireCampaignDetailsResponse,
  WireCampaignResponse,
  WireCampaignElementImage,
} from './types';

export const unmarshalCampaignId = (
  campaign: WireCampaignDetailsResponse
): string => campaign.id;

export const unmarshalCampaignDisclaimer = (
  campaign: WireCampaignDetailsResponse
): string => campaign.disclaimer.standard;

export const unmarshalCampaignImageUrl = (
  campaignElementImages: WireCampaignElementImage[]
): string =>
  campaignElementImages.find((image) => image.type === 'page')?.url ?? '';

export const unmarshalCampaignAdjustments = (
  campaign: WireCampaignDetailsResponse
): CampaignAdjustment[] =>
  campaign?.adjustments.map(({ percentageValue, type }) => ({
    percentageValue,
    type,
  }));

export const unmarshalCampaignElements = (
  campaign: WireCampaignDetailsResponse
): CampaignElement[] =>
  campaign?.elements.map((element) => ({
    type: element.name as CampaignElementType,
    description: element.copyDescription,
    imageUrl: unmarshalCampaignImageUrl(element.images),
  }));

export const unmarshalCampaign = (
  campaign: WireCampaignDetailsResponse
): Campaign => ({
  id: unmarshalCampaignId(campaign),
  elements: unmarshalCampaignElements(campaign),
  disclaimer: unmarshalCampaignDisclaimer(campaign),
  adjustments: unmarshalCampaignAdjustments(campaign),
});

export const unmarshalCampaignResponse = (
  response: WireCampaignResponse
): ApiData<Campaign> => {
  const campaign = response.payload.campaign[0];

  return makeApiSuccess(unmarshalCampaign(campaign));
};
